import { render, staticRenderFns } from "./EmailConfig.vue?vue&type=template&id=e4c4d70c&scoped=true"
import script from "./EmailConfig.vue?vue&type=script&lang=js"
export * from "./EmailConfig.vue?vue&type=script&lang=js"
import style0 from "./EmailConfig.vue?vue&type=style&index=0&id=e4c4d70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c4d70c",
  null
  
)

export default component.exports